import React from "react";
import { graphql, Link, PageProps, useStaticQuery } from "gatsby";
import { Button, Container, ListGroup, Offcanvas } from "react-bootstrap";
import DefaultLayout from "../../../layouts/default/default.layout";
import { TeamLink } from "../../../../utils/functions";

import Card3d2023Component from "./components/_card-3d-2023.component";

import * as TeamPageStyles from "./_2023-detail.module.scss";

export const Team2023DetailsPage: React.FC<PageProps<Queries.MDXSlugPageQuery>> = (props) => {
    const team = props.data.mdx!;
    const frontmatter = team.frontmatter!;
    const children = props.children;

    const teams = useStaticQuery(graphql`
        query AllTeams2023MDX {
            allMdx(filter: { frontmatter: { year: { eq: 2023 } } }, sort: { frontmatter: { name: ASC } }) {
                nodes {
                    id
                    frontmatter {
                        name
                        slug
                    }
                }
            }
        }
    `) as Queries.AllTeams2023MDXQuery;

    const [showSidebar, setShowSidebar] = React.useState(false);

    const links = teams.allMdx.nodes.map((n) => (
        <Link to={TeamLink(2023, n.frontmatter?.slug)} key={n.id} className="underline d-block w-100">
            <ListGroup.Item active={team.id === n.id}>{n.frontmatter?.name}</ListGroup.Item>
        </Link>
    ));

    const idx = teams.allMdx.nodes.findIndex((node) => node.id === team.id);
    let [prev, next]: (null | React.ReactElement)[] = [null, null];
    if (idx >= 0) {
        const prevObj = teams.allMdx.nodes[idx - 1];
        const nextObj = teams.allMdx.nodes[idx + 1];
        if (!!prevObj)
            prev = (
                <Link type="button" className="ff-serif fw-bold btn btn-dark m-1" to={TeamLink(2023, prevObj.frontmatter?.slug)}>
                    Previous
                </Link>
            );
        if (!!nextObj)
            next = (
                <Link type="button" className="ff-serif fw-bold btn btn-dark m-1 ms-auto" to={TeamLink(2023, nextObj.frontmatter?.slug)}>
                    Next
                </Link>
            );
    }

    return (
        <DefaultLayout containerClass={TeamPageStyles.groupedContainer}>
            <Button variant="primary" className="ff-serif d-md-none sticky sticky-top me-auto my-3 ms-3" onClick={() => setShowSidebar(true)}>
                {" "}
                &lt; All Teams
            </Button>
            <Offcanvas className={TeamPageStyles.sidebar} onHide={() => setShowSidebar(false)} show={showSidebar} responsive="md" data-bs-theme="dark">
                <Offcanvas.Header closeButton className={TeamPageStyles.sidebarHeader}>
                    <Offcanvas.Title>2023 Teams</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ListGroup className={TeamPageStyles.sidebarList}>{links}</ListGroup>
                </Offcanvas.Body>
            </Offcanvas>

            <Container className={TeamPageStyles.aboutTeam}>
                <section className="d-flex flex-wrap justify-content-between align-items-center">
                    <div>
                        <h1>{frontmatter.name}</h1>
                        <h2>{frontmatter.sport}</h2>
                    </div>
                    <div className="text-end ms-auto">
                        <h2>
                            {frontmatter.city}, {frontmatter.state}
                        </h2>
                        <h3>
                            <i>{frontmatter.league}</i>
                        </h3>
                    </div>
                </section>
                {!!prev || !!next ? (
                    <section className="d-flex justify-content-between">
                        {prev}
                        {next}
                    </section>
                ) : null}

                <hr />

                <Card3d2023Component team={team} front_only={false} />

                <div className="py-3">{children}</div>
            </Container>
        </DefaultLayout>
    );
};

export default Team2023DetailsPage;
